module.exports = __webpack_public_path__ + "img/1484458838.899d6aea.jpg";